/**
 * Cache curto do módulo Gestão de vagas (/gestaoVagasModuloAtivo).
 *
 * O Menu lateral é remontado a cada troca de página, e mapa/GestaoVaga também
 * consultam a mesma rota. Sem cache, cada navegação dispara uma requisição nova.
 * Aqui a última resposta fica guardada por dominio+idProf durante TTL_MS e as
 * chamadas simultâneas compartilham a mesma requisição em voo.
 */

import ServicoAPI from "../../../servicos/ServicoAPI.js"
import { obterLocalizacaoProfissionalGestaoVaga } from "../../../servicos/gestaoVagaLocalizacao.js"

const TTL_MS = 30_000

let cache = null // { chave, ts, resultado }
let emVoo = null // { chave, promessa }

function chaveCache(dados) {
	return `${dados?.dominio ?? ""}|${dados?.idProf ?? ""}`
}

/** Descarta o cache (ex.: logout, troca de profissional ou ação que muda vagas). */
export function invalidarGestaoVagasModulo() {
	cache = null
	emVoo = null
}

/**
 * Módulo ativo + info das vagas, reaproveitando a resposta recente.
 * @param {object} dados contexto geral (dominio, idProf, token)
 * @param {{ forcar?: boolean }} [opcoes] forcar=true ignora o cache
 * @returns {Promise<{ geo: object|null, resposta: object|null }>}
 */
export async function obterGestaoVagasModulo(dados, opcoes = {}) {
	const forcar = !!opcoes.forcar
	const chave = chaveCache(dados)

	if (!forcar) {
		if (cache && cache.chave === chave && Date.now() - cache.ts < TTL_MS) {
			return cache.resultado
		}
		if (emVoo && emVoo.chave === chave) {
			return emVoo.promessa
		}
	}

	const promessa = (async () => {
		const geo = await obterLocalizacaoProfissionalGestaoVaga()
		const resposta = await ServicoAPI.gestaoVagasModuloAtivo(dados, geo)
		const resultado = { geo, resposta }
		cache = { chave, ts: Date.now(), resultado }
		return resultado
	})()

	emVoo = { chave, promessa }
	try {
		return await promessa
	} finally {
		if (emVoo?.promessa === promessa) {
			emVoo = null
		}
	}
}
